import { apiGet } from './api/api-helpers';

export interface HealthResponse {
  status: string;
  version: string;
  uptime: number;
  timestamp: string;
}

export const healthService = {
  checkHealth: () => apiGet<HealthResponse>('/api/health'),
};
